// Klaviyo Stars Responsive Width Detection
function updateKlaviyoContainerClasses() {
  const containers = document.querySelectorAll('.klaviyo-star-rating-widget-container');
  
  containers.forEach(container => {
    const width = container.offsetWidth;
    
    if (width >= 200) {
      container.classList.add('wide-enough');
    } else {
      //container.classList.remove('wide-enough');
    }
  });
}

// Initialisation
function initKlaviyoResponsive() {
  updateKlaviyoContainerClasses();
  
  // Observer les changements de taille
  const resizeObserver = new ResizeObserver(() => {
    updateKlaviyoContainerClasses();
  });
  
  // Observer tous les conteneurs Klaviyo
  const containers = document.querySelectorAll('.klaviyo-star-rating-widget-container');
  containers.forEach(container => {
    resizeObserver.observe(container);
  });
}

// Auto-initialisation
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initKlaviyoResponsive);
} else {
  initKlaviyoResponsive();
}

// Exposer pour utilisation dynamique
window.updateKlaviyoContainerClasses = updateKlaviyoContainerClasses;
window.initKlaviyoResponsive = initKlaviyoResponsive; 